export const siteSettings = {
  name: "Digital Assets Custody",
  link: "https://digitalassetscustody.net",
  email: "support@digitalassetscustody.net",
  appLink: "https://app.digitalassetscustody.net",
};
